<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        class="catalog-title"
      >
        <h5
          class="gift-card-catalog-header px-10 py-0 mb-2 text-h5 black--text"
          aria-label="Select one or multiple gift cards."
          tabindex="0"
        >
          {{ sectionTitle }}
        </h5>
        <p
          class="gift-card-catalog-subheader px-10 py-0 mb-2 grey--text text--darken-3"
          tabindex="1"
        >
          {{ sectionDescription }}
        </p>
      </v-col>
    </v-row>
    <reward-card-row
      v-for="(brandRow, rowIndex) in dataArray"
      :key="`${sectionTitle}-${rowIndex}`"
      :brand-row="brandRow"
      :row-index="rowIndex"
      :selected="selected"
      :number-of-e-card-rows="numberOfECardRows"
      @brand-clicked="brandClicked"
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
      @close="close"
    />
  </v-container>
</template>

<script>
import RewardCardRow from '@/components/shared/reward-card-row/RewardCardRow'

export default {
  name: 'RewardCardGrid',
  components: { RewardCardRow },
  props: {
    dataArray: {
      type: Array,
      required: false,
      default: () => []
    },
    selected: {
      type: Object,
      required: false,
      default: () => {}
    },
    numberOfECardRows: {
      type: Number,
      required: false,
      default: 0
    },
    sectionDescription: {
      type: String,
      required: false,
      default: ''
    },
    sectionTitle: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    brandClicked (brand, row, trianglePosition) {
      this.$emit('brand-clicked', brand, row, trianglePosition)
    },
    beforeEnter (element) {
      this.$emit('before-enter', element)
    },
    enter (element) {
      this.$emit('enter', element)
    },
    afterEnter (element) {
      this.$emit('after-enter', element)
    },
    beforeLeave (element) {
      this.$emit('before-leave', element)
    },
    leave (element) {
      this.$emit('leave', element)
    },
    afterLeave (element) {
      this.$emit('after-leave', element)
    },
    close (event) {
      this.$emit('close', event)
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/css/variables';

.catalog-title {
  .gift-card-catalog-header {
    font-size: $font-size-xxl;
    font-family: Gotham-Book, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 60px 0 20px;
    color: $tangoTextPrimary;
  }
  // This id-level duplication was added here because this is also present in mango, and the mango styling
  // is unintentionally overriding the settings in the class styling above. See RL-2319
  .gift-card-catalog-subheader {
    font-size: $font-size-sm;
    font-family: Gotham-Book, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 60px 0 20px;
    color: $tangoTextSecondary;
  }
}
@media screen and (max-width: $breakpoint-lg - 1) {
  .catalog-title {
    h2.gift-card-catalog-header {
      padding: 20px 0 15px;
    }
  }
}
</style>
